export default __webpack_public_path__ + "static/media/Initiate's Hood of the Crescent.ccda8646.jpg";